<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import AudioPlayer66 from 'comp/common/AudioPlayer/AudioPlayer66'
import CheckMoreText from '../common/CheckMoreText.vue'

import { mapGetters } from 'vuex'
import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp66',
  components: { ModuleTitle, AudioPlayer66, CheckMoreText },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      audioList: this.moduleOption.list
    }
  },
  computed: {
    ...mapGetters({
      currentModalNameGetter: 'config/getCurrentModalName',
      dialogIsShowGetter: 'config/getDialogIsShow'
    }),
    currentModalName() {
      return this.currentModalNameGetter
    },
    dialogIsShow: {
      get() {
        return this.dialogIsShowGetter
      },
      set(v) {}
    }
  },
  watch: {
    dialogIsShow(newVal, oldVal) {
      if (newVal) {
        this.audioList.forEach(item => {
          item.isplaying = false
        })
      }
    }
  },
  created() {
    this.audioList.forEach(item => this.$set(item, 'isplaying', false))
  },
  methods: {
    getShadowColor,
    handleAudioClick(idx) {
      this.audioList.forEach((item, index) => {
        index === idx
          ? item.isplaying = !item.isplaying
          : item.isplaying ? item.isplaying = false : ''
      })
    },
    onCheckMore() {
      this.$store.commit('config/SET_CURRENT_MODALNAME', this.moduleOption.title)
      this.$store.commit('config/SET_DIALOG', true)
    }
  }
}
</script>

<template>
  <div class="modules-id-66">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-66-content pointer">
      <audio-player66
        v-for="(v, i) in audioList.slice(0, 3)"
        :key="`modules-66-${i}`"
        ref="audioGroup"
        :audiourl="v.typename"
        :title="v.headline"
        :publisher="v.name"
        :idx="i"
        :isplaying="v.isplaying"
        @handleAudioClick="handleAudioClick"
      />
      <check-more-text @click.native="onCheckMore" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-66-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
}
</style>
